import type { DashStoreState } from '../types/appState';

export const getWsConnectionFailed = (state: DashStoreState): boolean => state.network?.wsConnectionFailed ?? false;
